/* src/services/translations/routerTranslation.js */
export const routerTranslation = {
  en: {
    Page: "Page",
    "/": "Home",
    "/login": "Login",
    "/otp-login": "OTP Login",
    "/reports": "Reports",
    "/transactions": "Transactions",
    "/transactions/subscriptions": "Subscriptions",
    "/transactions/invoices": "Invoices",
    "/transactions/invoices/add": "Add Invoice",
    "/transactions/invoices/edit/:invoiceId": "Edit Invoice",
    "/transactions/payments": "Payments",
    "/transactions/coupons": "Coupons",
    "/transactions/payment-types": "Payment Types",
    "/submissions": "Submissions",
    "/templates": "Templates",
    "/companies": "Companies",
    "/companies/edit-company/:companyId": "Edit Company",
    "/teams": "Teams",
    "/users": "Users",
    "/transactions/plans-features": "Plans & Features",
    "/transactions/plans-features/plans": "Plans",
    "/transactions/plans-features/plans/add-plan": "Add Plan",
    "/transactions/plans-features/plans/edit-plan/:planId": "Edit Plan",
    "/transactions/plans-features/features": "Features",
    "/landing": "Landing",
    "/landing/blogs": "Blogs",
    "/landing/news": "News",
    "/landing/company-certificate": "Company Certificate",
    "/landing/company-files": "Company Files",
    "/landing/contact-us": "Contact Us",
    "/landing/customers": "Customers",
    "/landing/custom-pages": "Custom Pages",
    "/landing/faqs": "FAQs",
    "/landing/landing-general-settings": "Landing General Settings",
    "/landing/memberships": "Memberships",
    "/landing/newsletter-subscription": "Newsletter Subscription",
    "/landing/our-values": "Our Values",
    "/landing/partners": "Partners",
    "/landing/services": "Services",
    "/landing/social-media": "Social Media",
    "/landing/team-members": "Team Members",
    "/landing/tutorials": "Tutorials",
    "/landing/careers": "Careers",
    "/landing/careers/jobs": "Jobs",
    "/landing/careers/applicants": "Applicants",
    "/landing/pages-introductions": "Pages Introductions",
    "/landing/landing-slider": "Landing Slider",
    "/landing/sitemap-url": "Sitemap URL",
    "/settings": "Settings",
    "/settings/account": "Account",
    "/settings/audit-logs": "Audit Logs",
    "/settings/bulk-actions": "Bulk Actions Logs",
    "/settings/dsg-settings": "DSG Settings",
    "/settings/roles-permissions": "Roles & Permissions",
    "/settings/general-settings": "General Settings",
    "/settings/download-backups": "Download Backups",
    "/settings/tsa-settings": "TSA Settings",
    "/settings/trusted-roles": "Trusted Roles",
    "/trusted": "Trusted Roles Portal",
    "/trusted/login": "Trusted Roles Login",
    "/trusted/ro1/applications": "Applications to validate",
    "/trusted/ro1/applications/:id": "Application",
    "/trusted/ro2/applications": "Certificate issuance",
    "/trusted/ro2/applications/:id": "Application",
    "/trusted/revocations": "Revocations",
    "/trusted/tickets": "Complaints & reports",
    "/trusted/tickets/:reference": "Complaint / report",
    "/trusted/notifications": "Notifications",
    "/trusted/audit-logs": "Audit log",
  },
  ar: {
    Page: "الصفحة",
    "/": "الصفحة الرئيسية",
    "/login": "تسجيل الدخول",
    "/otp-login": "تسجيل الدخول برمز OTP",
    "/reports": "التقارير",
    "/transactions": "المعاملات",
    "/transactions/subscriptions": "الاشتراكات",
    "/transactions/invoices": "الفواتير",
    "/transactions/invoices/add": "إضافة فاتورة",
    "/transactions/invoices/edit/:invoiceId": "تعديل الفاتورة",
    "/transactions/payments": "المدفوعات",
    "/transactions/coupons": "القسائم",
    "/transactions/payment-types": "أنواع الدفع",
    "/submissions": "التقديمات",
    "/templates": "القوالب",
    "/companies": "الشركات",
    "/companies/edit-company/:companyId": "تعديل الشركة",
    "/teams": "الفرق",
    "/users": "المستخدمون",
    "/transactions/plans-features": "الخطط والميزات",
    "/transactions/plans-features/plans": "الخطط",
    "/transactions/plans-features/plans/add-plan": "إضافة خطة",
    "/transactions/plans-features/plans/edit-plan/:planId": "تعديل الخطة",
    "/transactions/plans-features/features": "الميزات",
    "/landing": "الصفحة الرئيسية",
    "/landing/blogs": "المدونات",
    "/landing/news": "الأخبار",
    "/landing/company-certificate": "شهادة الشركة",
    "/landing/company-files": "ملفات الشركة",
    "/landing/contact-us": "اتصل بنا",
    "/landing/customers": "العملاء",
    "/landing/custom-pages": "الصفحات المخصصة",
    "/landing/faqs": "الأسئلة الشائعة",
    "/landing/landing-general-settings": "إعدادات الصفحة الرئيسية العامة",
    "/landing/memberships": "العضويات",
    "/landing/newsletter-subscription": "الاشتراك في النشرة الإخبارية",
    "/landing/our-values": "قيمنا",
    "/landing/partners": "الشركاء",
    "/landing/services": "الخدمات",
    "/landing/social-media": "وسائل التواصل الاجتماعي",
    "/landing/team-members": "أعضاء الفريق",
    "/landing/tutorials": "الدروس",
    "/landing/careers": "الوظائف",
    "/landing/careers/jobs": "الوظائف",
    "/landing/careers/applicants": "المتقدمون",
    "/landing/pages-introductions": "مقدمات الصفحات",
    "/landing/landing-slider": "سلايدر الصفحة الرئيسية",
    "/landing/sitemap-url": "رابط خريطة الموقع",
    "/settings": "الإعدادات",
    "/settings/account": "الحساب",
    "/settings/audit-logs": "سجلات التدقيق",
    "/settings/bulk-actions": "سجلات الإجراءات المجمعة",
    "/settings/dsg-settings": "إعدادات DSG",
    "/settings/roles-permissions": "الأدوار والصلاحيات",
    "/settings/general-settings": "الإعدادات العامة",
    "/settings/download-backups": "تنزيل النسخ الاحتياطية",
    "/settings/tsa-settings": "إعدادات TSA",
    "/settings/trusted-roles": "الأدوار الموثوقة",
    "/trusted": "بوابة الأدوار الموثوقة",
    "/trusted/login": "دخول الأدوار الموثوقة",
    "/trusted/ro1/applications": "طلبات بانتظار التحقق",
    "/trusted/ro1/applications/:id": "الطلب",
    "/trusted/ro2/applications": "إصدار الشهادات",
    "/trusted/ro2/applications/:id": "الطلب",
    "/trusted/revocations": "الإلغاءات",
    "/trusted/tickets": "الشكاوى والبلاغات",
    "/trusted/tickets/:reference": "شكوى / بلاغ",
    "/trusted/notifications": "الإشعارات",
    "/trusted/audit-logs": "سجل التدقيق",
  },
};

export const ROUTE_TITLE_PATTERNS = [
  {
    pattern: /^\/trusted\/ro1\/applications\/[^/]+$/i,
    key: "/trusted/ro1/applications/:id",
  },
  {
    pattern: /^\/trusted\/ro2\/applications\/[^/]+$/i,
    key: "/trusted/ro2/applications/:id",
  },
  {
    pattern: /^\/trusted\/tickets\/[^/]+$/i,
    key: "/trusted/tickets/:reference",
  },
  {
    pattern: /^\/companies\/edit-company\/[^/]+$/i,
    key: "/companies/edit-company/:companyId",
  },
  {
    pattern: /^\/transactions\/plans-features\/plans\/edit-plan\/[^/]+$/i,
    key: "/transactions/plans-features/plans/edit-plan/:planId",
  },
  {
    pattern: /^\/transactions\/invoices\/edit\/[^/]+$/i,
    key: "/transactions/invoices/edit/:invoiceId",
  },
];

export const resolveRouteTitleKey = (pathname) => {
  if (!pathname) return null;

  const normalized = pathname.replace(/^\/Landing\b/, "/landing");

  if (Object.prototype.hasOwnProperty.call(routerTranslation.en, normalized)) {
    return normalized;
  }

  for (const { pattern, key } of ROUTE_TITLE_PATTERNS) {
    if (pattern.test(normalized)) return key;
  }

  return null;
};
